<template>
    <div :class="['z-20 lg:flex min-h-screen w-full lg:w-1/6 inline-block fixed left-0 top-0 bg-white menu shadow-lg flex',
     menuOpen ? 'flex' : 'hidden']">
        <div class="min-h-screen flex-shrink-0 menu__sidebar w-2"></div>
        <div class="flex flex-col justify-between pb-4 w-full pt-20 lg:pt-0">
            <div class="pl-5 pr-8">
                <Link :href="route($page.props.locale + '.dashboard')" class="h-28 mb-3 hidden lg:flex justify-center items-center">
                    <BreezeApplicationLogo class="w-full fill-current text-gray-500" />
                </Link>

                <BreezeNavLink v-for="link in menuItems"
                               class="menu__item flex items-center mb-7 lg:text-sm"
                               :active="active(link.route)"
                               :href="route($page.props.locale + '.' + link.route)">
                    <component :is="link.icon" class="mr-3 flex-shrink-0"/>
                    {{ $__(link.translationKey) }}
                </BreezeNavLink>
            </div>

            <div class="fixed lg:relative bottom-0 w-full">
                <LangSwitch />
                <hr class="border-gray-200 border-b-1 mt-auto lg:pr-8 w-full">
                <div class="h-20 mb-2 w-full flex">
                    <a :href="route($page.props.locale + '.logout')" class="text-sm flex justify-end lg:justify-start ml-auto lg:ml-0 pr-8 lg:pr-0 pl-5 pt-3 mb-auto lg:mr-auto menu__logout">
                        <LogoutIcon class="mr-3" />
                        {{ $__('menu.nav_logout') }}
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BreezeApplicationLogo from '@/Components/ApplicationLogo.vue';
import BreezeNavLink from '@/Components/NavLink.vue'
import HomeIcon from "@/Components/Icons/Home.vue";
import LogoutIcon from "@/Components/Icons/Logout.vue";
import GraduationCapIcon from "@/Components/Icons/GraduationCap.vue";
import LightBulbIcon from "@/Components/Icons/LightBulb.vue";
import { Link } from '@inertiajs/inertia-vue3';
import NavLink from '@/Components/NavLink';
import LangSwitch from '@/Components/LangSwitch';

export default {
    components: {
        NavLink, LogoutIcon, LangSwitch,
        BreezeApplicationLogo, BreezeNavLink, Link, HomeIcon, GraduationCapIcon, LightBulbIcon
    },
    methods: {
        active(itemRoute){
            return route().current(this.$page.props.locale + '.' + itemRoute)
        },
    },
    props: ['menuOpen'],
    data() {
        return {
            menuItems: {
                dashboard: {
                    icon: "HomeIcon",
                    translationKey: "menu.nav_dashboard",
                    route: "dashboard"
                },
                opportunities: {
                    icon: "GraduationCapIcon",
                    translationKey: "menu.nav_opportunities",
                    route: "opportunities"
                },
                kennisbank: {
                    icon: "LightBulbIcon",
                    translationKey: "menu.nav_kennisbank",
                    route: "kennisbank"
                }
            }
        };
    }
}
</script>
